<template>
    <div>
        <main class="d-flex justify-content-center inicio-home">
            
            <div class="container p-5">
                <div class="row d-flex justify-content-center">
                <div class="col-md-8  bg-body rounded shadow-sm p-5">
                    <div><img class="mb-4 mx-auto d-block" src="img/verificando.png" alt="" width="107px">
                    <p class="text-center t-v">Verificando operación</p>
                    <p class="text-center">Código de operación: <span>000015</span>  </p>
                    </div>
                        
                <div class="d-flex justify-content-between">
                        <div class="col-md-6 d-flex justify-content-start">
                            <ul class="list-ope">
                                <li class="item-op-1">Enviaste</li>
                                <li class="moneda">S/300</li>
                                <li class=""> <span> Vendiste a:</span> 3.2012</li>
                            </ul>
                        </div>
                        <div class="col-md-6 d-flex justify-content-end">
                            <ul class="list-ope">
                                <li class="item-op-1">Recibiste</li>
                                <li class="moneda">$/90</li>
                                <li class="">28/07/2021</li>
                            </ul>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="col-md-6 d-flex justify-content-start">
                            <ul class="list-ope">
                                <li class="item-op-1">Nombre de la cuenta: </li>
                                <li class="">Cuenta</li>
                                <li class="">Banco</li>
                                <li class="">Tipo</li>
                                <li class="">Moneda</li>
                            </ul>
                        </div>
                        <div class="col-md-6 d-flex justify-content-end">
                            <ul class="list-ope">
                                <li class="moneda">BCP DÓLARES</li>
                                <li class="">00000000000</li>
                                <li class="">BCP</li>
                                <li class="">Corriente</li>
                                <li class="">Dólares</li>
                            </ul>
                        </div>
                     </div>
                </div>
            </div>
            </div>
        </main>
   


</div>
</template>

<script>
import moment from 'moment'

  export default {
    name: "OperacionesVerificando",

    data() {
    return {
     
    };
  },
    methods:{
      
    },
  };
  </script>


// WEBPACK FOOTER //
// src/components/user/DetalleOperacionesVerificadas.vue